module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAPCAYAAADd/14OAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADkSURBVHgBndI9igIxFADg9/KYLRfLhWWHsKMgOoLTWepJxBN4BPUkWlp6A4/gVCLYvNLOUazUJL5go86oYCDJS/LlhyQIL9JvpdYki/2jMSN6hsKo3lWOphK2CNUOnyEAnPhYwAzNoZdH//EgjGLn81/UmBRvd4PCcjz8HMkW43cItW6WLJ2316bjvQmSjNPsESqWTqVsInHm532TWfzoqs5BX/B6mQrugHMsq+ovCuaP+O4etQxaRXNAFIR8NKfOhlecg69w4cvcY8iMHEsVQZYVlA0ScJBKs0QG2/AuaflBvr4AZVBfwNGW2LkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/back.png
// module id = 976
// module chunks = 0